import * as React from "react";
import { Button } from "react-bootstrap"

import { SimpleComponent } from "./SimpleComponent"
import { getStyle } from "./navigation"

import Models = Gf.Web.Models;

export interface IClickButtonProps {
    className?: string;
    onClick: React.MouseEventHandler<{}>;
    disabled?: boolean;
    flagg?: Models.HandlingFlagg;
}

/**
 * A button which navigates to the "to" path
 */
export class ClickButton extends SimpleComponent<IClickButtonProps> {
    constructor(props: IClickButtonProps) {
        super(props);
    }

    render() {
        return <Button disabled={this.props.disabled}
                       bsStyle={getStyle(this.props.flagg || Models.HandlingFlagg.Standard)}
                       /* className={this.props.className || "defaultButton"} */
                       onClick={this.props.onClick}>{this.props.children}</Button>;
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/ClickButton.tsx